const MAP = {
  connected: { label: "🟢 متصل", cls: "bg-green-100 text-green-800 border-green-300" },
  qr: { label: "🟡 بانتظار مسح الرمز", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  connecting: { label: "🟡 جاري الاتصال", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  disconnected: { label: "🔴 غير متصل", cls: "bg-red-100 text-red-700 border-red-300" },
};

export const StatusChip = ({ status }) => {
  const s = MAP[status] || MAP.disconnected;
  return (
    <span
      data-testid="whatsapp-status-chip"
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold ${s.cls}`}
    >
      {s.label}
    </span>
  );
};

const MSG_MAP = {
  sent: { label: "تم الإرسال", cls: "bg-green-100 text-green-800" },
  failed: { label: "فشل الإرسال", cls: "bg-red-100 text-red-700" },
  sending: { label: "قيد الإرسال", cls: "bg-amber-100 text-amber-800" },
};

export const MessageStatusChip = ({ status }) => {
  const s = MSG_MAP[status] || MSG_MAP.sending;
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export default StatusChip;
